import { render, staticRenderFns } from "./detailStickerVa.vue?vue&type=template&id=4fb5b208&scoped=true"
import script from "./detailStickerVa.vue?vue&type=script&lang=js"
export * from "./detailStickerVa.vue?vue&type=script&lang=js"
import style0 from "./detailStickerVa.vue?vue&type=style&index=0&id=4fb5b208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5b208",
  null
  
)

export default component.exports